import config from '../config';

/**
 * Environment debugging utility
 * Use this to check your environment configuration
 */
export const debugEnvironment = () => {
  console.group('🔧 Environment Configuration');
  console.log('API URL:', config.API_URL);
  console.log('App Name:', config.APP_NAME);
  console.log('App Version:', config.APP_VERSION);
  console.log('Environment:', config.NODE_ENV);
  console.log('Is Development:', config.IS_DEVELOPMENT);
  console.log('Is Production:', config.IS_PRODUCTION);
  console.log('Social Login Enabled:', config.ENABLE_SOCIAL_LOGIN);
  console.log('Registration Enabled:', config.ENABLE_REGISTRATION);
  console.log('API Timeout:', config.DEFAULT_TIMEOUT);
  console.log('Max File Size:', config.MAX_FILE_SIZE);
  console.groupEnd();
};

/**
 * Check if all required environment variables are set
 */
export const validateEnvironment = () => {
  const issues: string[] = [];

  if (!config.API_URL) {
    issues.push('REACT_APP_API_URL is not set');
  }

  if (!config.APP_NAME) {
    issues.push('REACT_APP_NAME is not set');
  }

  if (config.DEFAULT_TIMEOUT < 1000) {
    issues.push('REACT_APP_API_TIMEOUT should be at least 1000ms');
  }

  if (config.MAX_FILE_SIZE < 1024) {
    issues.push('REACT_APP_MAX_FILE_SIZE should be at least 1024 bytes');
  }

  if (issues.length > 0) {
    console.group('⚠️ Environment Issues');
    issues.forEach(issue => console.warn(issue));
    console.groupEnd();
    return false;
  }

  console.log('✅ Environment configuration is valid');
  return true;
};

/**
 * Get environment info for display in UI
 */
export const getEnvironmentInfo = () => {
  return {
    appName: config.APP_NAME,
    version: config.APP_VERSION,
    environment: config.NODE_ENV,
    apiUrl: config.IS_DEVELOPMENT ? config.API_URL : '[Hidden in production]',
    features: {
      socialLogin: config.ENABLE_SOCIAL_LOGIN,
      registration: config.ENABLE_REGISTRATION,
    },
  };
};
